import { createFileRoute } from '@tanstack/react-router'
import { TicketDetail } from '../../../pages/TicketDetail'

export const Route = createFileRoute('/helpdesk/tickets/$id')({
  component: TicketDetail,
})